<template>
  <PageWrapper :isLoading="isLoading" hasFilters @submitFilters="getAllMatches">
    <template #title> لیست مسابقات </template>
    <template #titleBtn>
      <BButton variant="success" @click="renderCreateMatchDialog">
        ساخت مسابقه جدید
      </BButton>
    </template>
    <template #filters>
      <SearchInput
        class="filters-width w-24"
        inputLabel="جستجوی نام مسابقه"
        inputPlaceholder="جستجو..."
        v-model="getAllMatchFilters.searchCommand"
        @enter="getAllMatches"
      ></SearchInput>
      <RangeDatePicker
        class="w-24 filters-width"
        label="بازه‌ی تاریخ منابع درآمد را وارد کنید"
        @getDateRange="setDateRange"
      ></RangeDatePicker>
    </template>
    <CustomTable
      v-if="matchList"
      :pageNumber="getAllMatchFilters.pageNumber"
      :count="getAllMatchFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="matchList"
      @changePage="changePage"
    >
      <template #actions="data">
        <BButton
          size="sm"
          variant="transparent"
          v-b-tooltip="'جزئیات مسابقه'"
          :to="`/apps/matches/${data.item.id}`"
        >
          <FeatherIcon icon="ExternalLinkIcon" class="text-info" size="23" />
        </BButton>
        <BButton
          size="sm"
          variant="transparent"
          v-b-tooltip="'افزودن کاربر به مسابقه'"
          @click="renderAddUserToMatchDialog(data.item)"
        >
          <FeatherIcon icon="PlusCircleIcon" class="text-success" size="23" />
        </BButton>
      </template>
    </CustomTable>
    <CreateMatchDialog @refetch="getAllMatches"></CreateMatchDialog>
    <AddUserToMatchDialog
      @refetch="getAllMatches"
      :selectedMatch="tempSelectedMatch"
    ></AddUserToMatchDialog>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getAllMatches();
  },
  data() {
    return {
      isLoading: false,
      matchList: null,
      totalCount: null,
      tempSelectedMatch: null,
      getAllMatchFilters: {
        pageNumber: 1,
        count: 10,
        searchCommand: null,
        from: null,
        to: null,
      },
      tableColumns: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "title",
          label: "عنوان مسابقه",
        },
        {
          key: "matchQuestionsCount",
          label: "تعداد سوال های مسابقه",
          formatter: (val) => `${val} سوال`,
        },
        {
          key: "matchSettingsTitle",
          label: "عنوان تنظیمات مسابقه",
        },
        {
          key: "matchUsersCount",
          label: "تعداد شرکت کنندگان",
          formatter: (val) => `${val} نفر`,
        },
        {
          key: "createAt",
          label: "تاریخ ایجاد",
          formatter: (val) =>
            `${this.customFullDateConvert(
              val
            )} - ${this.customConvertHourAndMinute(val)}`,
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    changePage(pageNumber) {
      this.getAllMatchFilters.pageNumber = pageNumber;
      this.getAllMatches();
    },
    async getAllMatches() {
      try {
        this.isLoading = true;
        const _this = this;
        const getAllMatches = new GetAllMatches(_this);
        getAllMatches.setRequestParam(_this.getAllMatchFilters);
        await getAllMatches.fetch((res) => {
          _this.matchList = res.data.data;
          _this.totalCount = res.data.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setDateRange(dateRange) {
      if (dateRange && dateRange.length > 0) {
        this.getAllMatchFilters.from = new Date(dateRange[0]).toISOString();
        this.getAllMatchFilters.to = new Date(dateRange[1]).toISOString();
      } else {
        this.getAllMatchFilters.from = null;
        this.getAllMatchFilters.to = null;
      }
    },
    renderAddUserToMatchDialog(selectedMatch) {
      this.tempSelectedMatch = selectedMatch;
      this.$bvModal.show("add-user-to-match-dialog");
    },
    renderCreateMatchDialog() {
      this.$bvModal.show("create-match-dialog");
    },
  },
  mixins: [timeConvertUtils],
  directives: {
    BTooltip: VBTooltip,
  },
  components: {
    PageWrapper,
    CreateMatchDialog,
    AddUserToMatchDialog,
    RangeDatePicker,
    SearchInput,
    CustomTable,
    BButton,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CreateMatchDialog from "@/views/components/Matches/CreateMatchDialog.vue";
import AddUserToMatchDialog from "@/views/components/Matches/AddUserToMatchDialog.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import RangeDatePicker from "@/views/components/Utils/RangeDatePicker.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import timeConvertUtils from "@/mixins/timeConvertUtils";
import { BButton, VBTooltip } from "bootstrap-vue";
import { GetAllMatches } from "@/libs/Api/Matches";
</script>
